"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var setData_1 = require("./setData");
var defaultValue_1 = require("./defaultValue");
/**
 * Naprawia dane, ustawiając domyślne wartości w polach
 * @param schema schemat
 * @param data dane
 * @param Vue kontsruktor Vue
 */
/**
 * Naprawia dane, ustawiając domyślne wartości w polach
 *
 * @export
 * @param {JSONSchema} schema
 * @param {*} data
 * @param {*} [Vue]
 * @returns {number} zwraca liczbę naprawionych pól
 */
function fixData(schema, data, Vue, force) {
    if (force === void 0) { force = true; }
    var result = 0;
    if (schema.type === 'object') {
        var props = schema.properties;
        for (var key in schema.properties) {
            if (props.hasOwnProperty(key)) {
                var pschema = props[key];
                if (data[key] === undefined) {
                    (0, setData_1.setDataValue)(pschema, data, key, (0, defaultValue_1.default)(pschema, force), Vue);
                    result++;
                }
                else if (data[key] === null && (pschema.type === 'array' || pschema.type === 'object')) {
                    (0, setData_1.setDataValue)(pschema, data, key, (0, defaultValue_1.default)(pschema, force), Vue);
                    result++;
                }
                else {
                    result += fixData(pschema, data[key], Vue, force);
                }
            }
        }
    }
    else if (schema.type === 'array') {
        var pschema = schema.items;
        // tslint:disable-next-line: prefer-for-of
        for (var i = 0; i < data.length; i++) {
            var value = data[i];
            result += fixData(pschema, value, Vue, force);
        }
    }
    return result;
}
exports.default = fixData;
//# sourceMappingURL=fixData.js.map